import * as z from "zod";

export const getWorkOrderStepTitles = {
  name: "getWorkOrderStepTitles" as const,
  input: z.object({}),
  output: z.object({ titles: z.array(z.string()) }),
};
